import ModulePlaceholder from './ModulePlaceholder'
import useWidgetPersona from './useWidgetPersona'

// AI-CONTEXT: See docs/features/livereport-per-deelnemer.md (T5, scenario 14)
// Nodig omdat CanvasNode de enige plek is waar editor, openbare link en PDF
// allemaal een widget renderen; zo hoeft geen totaalwidget de deelnemer zelf
// na te lopen, en kan een nieuwe er niet aan ontsnappen.

/** @typedef {import('../BaseWidget').BaseWidget} BaseWidget */

/**
 * Toont een melding in plaats van de widget wanneer die over alle deelnemers
 * telt (`countsAllPersonas()`) en het rapport over één deelnemer gaat. Niet
 * stil weglaten: de maker moet zien dat het blok hier niets zegt. Zonder
 * deelnemer rendert hij de widget ongewijzigd.
 *
 * @param {object} props
 * @param {BaseWidget} props.widget - The widget instance being rendered
 * @param {React.ReactNode} props.children - The widget's own rendered output
 * @returns {JSX.Element}
 */
const PersonaScopeGuard = ({ widget, children }) => {
    const personaId = useWidgetPersona()

    if (personaId && widget?.countsAllPersonas?.() === true) {
        return <ModulePlaceholder mode="persona" />
    }
    return <>{children}</>
}

export default PersonaScopeGuard
